import generateCrudEndpoints from '@packages/toolbox/dist/utils/endpoint-generator';
import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from '@packages/toolbox/dist/declarations/endpoint';

export const BASE_ORGANIZATION_URL = `${SERVER_API}/organizations`;

export const ORGANIZATION_ENDPOINTS = {
  ...generateCrudEndpoints(BASE_ORGANIZATION_URL),
  EXPORT: {
    method: 'POST',
    url: `${BASE_ORGANIZATION_URL}/export`,
  } as IEndpointData,
};
